"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EqualsFilterOperation = void 0;
/**
 * Used to define an equal comparator operation for filtering
 * @param field the name of the field
 * @param value the value of the field
 */
class EqualsFilterOperation {
    constructor(field, value) {
        this.field = field;
        this.value = value;
    }
}
exports.EqualsFilterOperation = EqualsFilterOperation;
